import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Mail, Check } from "lucide-react";
import api from "../lib/api";
import { useI18n } from "../context/I18nContext";

function Toggle({ checked, onChange, label }) {
  return (
    <button type="button" onClick={() => onChange(!checked)}
      className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-md border text-left transition-colors ${checked ? "bg-cyan-400/10 border-cyan-400/50" : "bg-zinc-900/50 border-zinc-800 hover:border-zinc-700"}`}>
      <span className={`h-5 w-5 rounded border flex items-center justify-center shrink-0 ${checked ? "bg-cyan-400 border-cyan-400" : "border-zinc-700"}`}>
        {checked && <Check className="h-3.5 w-3.5 text-black" />}
      </span>
      <span className="text-sm font-bold">{label}</span>
    </button>
  );
}

export default function ForgotPin() {
  const navigate = useNavigate();
  const { t } = useI18n();
  const [identifier, setIdentifier] = useState("");
  const [wantIdent, setWantIdent] = useState(false);
  const [wantPin, setWantPin] = useState(true);
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const nothingPicked = !wantIdent && !wantPin;

  const submit = async () => {
    if (!identifier.trim() || nothingPicked) return;
    setLoading(true);
    try {
      await api.post("/auth/forgot-pin", {
        identifier: identifier.trim(),
        want_identifiant: wantIdent,
        want_pin: wantPin,
      });
    } catch { /* réponse identique quoi qu'il arrive */ }
    finally { setLoading(false); setSent(true); }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] grain text-white flex items-center justify-center px-6">
      <div className="w-full max-w-sm space-y-6">
        <button onClick={() => navigate("/")} className="inline-flex items-center gap-2 text-zinc-500 hover:text-white text-sm">
          <ArrowLeft className="h-4 w-4" /> {t("reset.back_login")}
        </button>

        <div className="flex items-center gap-2">
          <Mail className="h-5 w-5 text-cyan-400" />
          <h1 className="font-heading font-black text-3xl uppercase tracking-tight">{t("reset.title")}</h1>
        </div>

        {sent ? (
          <div className="px-4 py-3 bg-cyan-400/5 border border-cyan-400/20 rounded-md text-sm text-cyan-300">
            {t("reset.sent")}
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <label className="block text-xs text-zinc-400 uppercase tracking-wider mb-1">{t("reset.identifier")}</label>
              <input
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                onKeyDown={(e) => { if (e.key === "Enter") submit(); }}
                className="w-full bg-zinc-800 border border-zinc-700 rounded-md px-3 py-2 text-white placeholder-zinc-600 focus:outline-none focus:border-cyan-400 text-sm"
              />
              <p className="mt-1 text-[11px] text-zinc-600">{t("reset.identifier_hint")}</p>
            </div>

            <div className="space-y-2">
              <div className="text-xs text-zinc-400 uppercase tracking-wider">{t("reset.what")}</div>
              <Toggle checked={wantIdent} onChange={setWantIdent} label={t("reset.want_identifiant")} />
              <Toggle checked={wantPin} onChange={setWantPin} label={t("reset.want_pin")} />
              {nothingPicked && <p className="text-[11px] text-red-400">{t("reset.pick_one")}</p>}
            </div>

            <button onClick={submit} disabled={loading || !identifier.trim() || nothingPicked}
              className="w-full bg-cyan-400 hover:bg-cyan-300 disabled:opacity-50 text-black font-bold uppercase tracking-wide py-2.5 rounded-md transition-colors text-sm">
              {loading ? "..." : t("reset.send")}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
